import { render, staticRenderFns } from "./PaymentDialog.vue?vue&type=template&id=6baa5cf2&scoped=true&lang=pug&"
import script from "./PaymentDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDialog.vue?vue&type=style&index=0&id=6baa5cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa5cf2",
  null
  
)

export default component.exports